import { AutoLoader } from "../../../shared/src/API/APIAutoloader";
import { fetchRequest, handleErrors, simpleGetRequest } from "../../../shared/src/API/baseAPI";
import { getAsElement, getAsString } from "../../../shared/src/UIController/stars";
import { showAlert } from "../../../shared/src/Util/alerts";
import * as util from "../../../shared/src/Util/helper";
import { addDropdownOption, toggleSelectDropdown, updateSelection } from "../../../shared/src/UIController/multiSelector";
import { createBadge, getTagNames, getTags } from "../../../shared/src/UIController/tags";
import eventBus from "../../../shared/src/events/eventBus";
import { createReviewCard } from "../../../shared/src/components/ReviewCard/reviewCard";

let listPage = 1;
let loaded = false;
let mapLoaded = false;
let fullyLoaded = false;

// global filter object
const filter = {
    city: '',
    zip: '',
    query: '',
    sort: '',
    price: -1,
    meat: [],
    star: 0,
    filters: [],
    openAt: undefined,
    ratingWeights: undefined,
    myLiked: 'all',
    myRated: 'all'
}

const cityNameToZip = Object.create(null);

function setCollapseOpen(collapseEl, open) {
    if (!collapseEl) return;

    // DaisyUI <details class="collapse"> variant
    if (collapseEl.tagName === 'DETAILS') {
        collapseEl.open = !!open;
        return;
    }

    // Legacy DaisyUI div-based variant
    if (open) {
        collapseEl.classList.add('collapse-open');
    } else {
        collapseEl.classList.remove('collapse-open');
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const reducedCity = cities.filter((city, index, self) =>
        index === self.findIndex((t) => (
            t.cityName === city.cityName
        ))
    ).sort((a, b) => {
        if (a.cityName < b.cityName) return -1;
        if (a.cityName > b.cityName) return 1;
        return 0;
    });

    const cityFilter = document.getElementById('city');
    for (const city of reducedCity) {
        if (city?.cityName && city?.zip && !cityNameToZip[city.cityName]) {
            cityNameToZip[city.cityName] = city.zip;
        }
        const option = document.createElement('option');
        option.value = city.cityName;
        option.innerText = city.cityName;
        option.onclick = () => {
            filter.city = city.cityName;
            filter.zip = city.zip;
            filterUpdate();
        }
        cityFilter.appendChild(option);
    }

    cityFilter.addEventListener('change', () => {
        cityUpdate();
    });

    const sortSelect = document.getElementById('sort');
    const sortSelect2 = document.getElementById('list-sort');
    // Populate sort select options
    for (const sort of sorts) {
        const option = document.createElement('li');
        const optionClone = document.createElement('li');
        option.id = 'sort-' + sort;
        optionClone.id = 'sort-' + sort + '-2';
        option.className = 'dropdown-item';
        optionClone.className = 'dropdown-item';
        option.classList.add('sort-option', 'cursor-pointer', 'p-2', 'border-b', 'border-gray-200', 'rounded', 'hover:bg-secondary', 'transition-colors', 'duration-200');
        optionClone.classList.add('sort-option', 'cursor-pointer', 'p-2', 'border-b', 'border-gray-200', 'rounded', 'hover:bg-secondary', 'transition-colors', 'duration-200');

        option.innerText = formatSortString(sort);
        optionClone.innerText = formatSortString(sort);
        sortSelect.appendChild(option);

        option.onclick = () => {
            sortUpdate(sort);
        }

        optionClone.onclick = () => {
            sortUpdate(sort);
        }

        sortSelect2.appendChild(optionClone);
    }

    for (const type of meatType) {
        if (type == 'unknown') {
            continue;
        }
        addDropdownOption('meat-dropdown', type);
    }

    for (const filter of filters) {
        addDropdownOption('filter-dropdown', filter);
    }
    
    getFilterQuery();
    updateFilterUI();
    updateInputs();
    switchView(util.getQueryParams()['v'] || 'map');

    initMap();

    setTimeout(() => {
        loaded = true;
        fetchData();
        new AutoLoader(['loader', 'reviewSkeleton', 'skeleton', 'drawer-review-skeleton'], fetchData);
    }, 700);
    
    requestLocation(false);

    const locationAddress = document.getElementById('location-address-short');
    const locationRate = document.getElementById('location-rate-short');
    
    locationAddress.addEventListener('click', function(e) {
        e.stopPropagation();
    });

    locationRate.addEventListener('click', function(e) {
        e.stopPropagation();
    });

    document.getElementById('mapTiler-btn').addEventListener('click', function(e) {
        e.stopPropagation();
    });

    document.getElementById('filter-btm-drawer-btn').addEventListener('click', function(e) {
        e.stopPropagation();
    });

    document.getElementById('location-btm-drawer-btn').addEventListener('click', function(e) {
        e.stopPropagation();
    });

    let startY;
    let startTransform;
    let isDragging = false;
    let isScrolling = false;
    let hasMoved = false;

    const drawer = document.getElementById('btm-drawer');
    const closeButton = document.querySelector('.close-button');

    function openDrawer() {
        drawer.classList.add('open');
        document.getElementById('footerWrapper').classList.remove('hidden');
    }

    function closeDrawer() {
        if (drawer.classList.contains('open')) {
            drawer.classList.remove('open');
        } else if (drawer.classList.contains('expanded-btm-drawer')) {
            drawer.classList.remove('expanded-btm-drawer');
            if (selectedMarker && selectedMarker.id) {
                closeReview(selectedMarker.id);
            }
        }
        document.getElementById('footerWrapper').classList.add('hidden');
    }

    function onStart(e) {
        if (isScrolling) return;
        e.preventDefault();
        isDragging = true;
        hasMoved = false;
        startY = e.type === 'mousedown' ? e.clientY : e.touches[0].clientY;
        const style = window.getComputedStyle(drawer);
        const matrix = new DOMMatrixReadOnly(style.transform);
        startTransform = matrix.m42;
        
        document.addEventListener('mousemove', onMove);
        document.addEventListener('touchmove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchend', onEnd);
    }

    function onMove(e) {
        if (!isDragging) return;
        hasMoved = true; 
        e.preventDefault();
        const currentTouch = e.type === 'mousemove' ? e.clientY : e.touches[0].clientY;
        const diff = currentTouch - startY;
        
        let newY = startTransform + diff;
        const maxY = window.innerHeight - 60;
        const minY = window.innerHeight * 0.2;
        newY = Math.max(minY, Math.min(maxY, newY));
        
        drawer.style.transform = `translateY(${newY}px)`;
    }

    function onEnd(e) {
        if (!isDragging) return;
        isDragging = false;
        
        const style = window.getComputedStyle(drawer);
        const matrix = new DOMMatrixReadOnly(style.transform);
        const currentY = matrix.m42;
        const diff = currentY - startTransform;
        const threshold = window.innerHeight * 0.5;

        if (!hasMoved) {
            return;
        }
        
        if (Math.abs(diff) > 7) {
            if (diff > 0) {
                closeDrawer();
            } else {
                openDrawer();
            }
        } else {
            if (currentY < threshold) {
                openDrawer();
            } else {
                closeDrawer();
            }
        }
        
        drawer.style.transform = '';
        
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchend', onEnd);
    }

    const dragArea = document.getElementById('btm-drawer-drag-area');
    dragArea.addEventListener('click', (e) => {
        if (!hasMoved) {
            if (!e.target.closest('#location-address-short') && 
                !e.target.closest('#location-rate-short') &&
                !e.target.closest('#location-view-short') &&
                !e.target.closest('#shareBtn')) {
                openDrawer();
            }
        }
    });

    closeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        closeDrawer();
    });

    document.getElementById('shareBtn').addEventListener('click', (e) => {
        e.stopPropagation();
        App.common.shareCurrentLocation();
    });

    const drawerHeader = document.querySelector('.btm-drawer-header');
    dragArea.addEventListener('mousedown', onStart);
    dragArea.addEventListener('touchstart', onStart);
    drawerHeader.addEventListener('mousedown', onStart);
    drawerHeader.addEventListener('touchstart', onStart);
});

export function toggleDropdown(id) {
    toggleSelectDropdown(id);
}

// multiSelector emits via eventBus (not DOM events).
eventBus.on('selection:update', (event) => {
    const dId = event?.dId;
    const selectedValues = event?.selectedValues;

    if (dId === 'meat-dropdown') {
        filter.meat = Array.isArray(selectedValues) ? selectedValues : [];
    } else if (dId === 'filter-dropdown') {
        filter.filters = Array.isArray(selectedValues) ? selectedValues : [];
    }

    filterUpdate();
});

export function searchUpdate() {
    filter.query = document.getElementById('search').value;
    filterUpdate();
}

function sortUpdate(sort) {
    filter.sort = sort;
    if (document.getElementById('sort-' + sort).classList.contains('bg-primary')) {
        filter.sort = '';
        document.getElementById('sort-' + sort).classList.remove('bg-primary');
        document.getElementById('sort-' + sort).classList.remove('text-gray-100');
        document.getElementById('sort-' + sort + '-2').classList.remove('bg-primary');
        document.getElementById('sort-' + sort + '-2').classList.remove('text-gray-100');
        document.getElementById('sort-text').innerHTML = '<i class="fa-solid fa-right-left"></i> Sort';
        document.getElementById('sort-text-2').innerHTML = '<i class="fa-solid fa-arrow-down-wide-short"></i> Sort';
    } else {
        document.querySelectorAll('.sort-option').forEach(option => {
            option.classList.remove('bg-primary');
            option.classList.remove('text-gray-100');
        });
        document.getElementById('sort-' + sort).classList.add('bg-primary');
        document.getElementById('sort-' + sort).classList.add('text-gray-100');
        document.getElementById('sort-' + sort + '-2').classList.add('bg-primary');
        document.getElementById('sort-' + sort + '-2').classList.add('text-gray-100');
        document.getElementById('sort-text').innerHTML = '<i class="fa-solid fa-right-left"></i> ' + formatSortString(sort);
        document.getElementById('sort-text-2').innerHTML = '<i class="fa-solid fa-arrow-down-wide-short"></i> ' + formatSortString(sort);
    }

    filterUpdate();
}

export function starUpdate() {
    filter.star = document.getElementById('filter-stars').value;
    filterUpdate();
}

export function priceUpdate(price) {
    if (document.getElementById('price-' + price).classList.contains('btn-primary')) {
        price = -1;
    }

    filter.price = price;

    document.querySelectorAll('.price-btn').forEach(btn => {
        btn.classList.remove('btn-primary');
    });

    if (price != -1) {
        document.getElementById('price-' + price).classList.add('btn-primary');
    }

    filterUpdate();
}

export function cityUpdate() {
    filter.city = document.getElementById('city').value;

    // If user selected a concrete cityName, also send a zip (used as a backend fallback).
    if (filter.city && filter.city !== 'dynamic' && filter.city !== 'all') {
        filter.zip = cityNameToZip[filter.city] || filter.zip;
    }

    filterUpdate();
}

export function advancedHoursUpdate() {
    const enabledEl = document.getElementById('advanced-hours-enabled');
    const dayEl = document.getElementById('advanced-hours-day');
    const timeEl = document.getElementById('advanced-hours-time');

    if (!enabledEl || !dayEl || !timeEl) {
        return;
    }

    if (!enabledEl.checked) {
        filter.openAt = undefined;
        filterUpdate();
        return;
    }

    const day = dayEl.value;
    const time = timeEl.value || '12:00';
    timeEl.value = time;

    filter.openAt = { day, time };

    const advancedHoursCollapse = document.getElementById('advanced-hours-collapse');
    setCollapseOpen(advancedHoursCollapse, true);

    // Avoid confusing combinations: advanced hours replaces the simple "open now" filter.
    if (Array.isArray(filter.filters) && filter.filters.includes('openNow')) {
        filter.filters = filter.filters.filter(f => f !== 'openNow');

        const openNowCheckbox = document.getElementById('openNow');
        if (openNowCheckbox && openNowCheckbox.checked) {
            openNowCheckbox.checked = false;
            updateSelection(openNowCheckbox);
            return;
        }
    }

    filterUpdate();
}

function weightsEnabled() {
    const weights = filter.ratingWeights;

    return weights && Object.values(weights).some(w => w != 1);
}

function getWeight(id) {
    return document.getElementById(id) ? Number(document.getElementById(id).value) : 1;
}

export function ratingWeightsUpdate() {
    const weights = {
        taste: getWeight('weight-taste'),
        sauce: getWeight('weight-sauce'),
        ingredients: getWeight('weight-ingredients'),
        presentation: getWeight('weight-presentation'),
        value: getWeight('weight-value'),
        ambiance: getWeight('weight-ambiance'),
    };

    filter.ratingWeights = weights;
    filterUpdate();
}


function filterUpdate() {
    if (mapFullyLoaded && loaded) {
        calcIndicator();
        updateQuery();
        forceFetchData();
    }
}

export function switchView(view) {
    eventBus.emit('view:switched', { view })
    const mapView = document.getElementById('map-view');
    const listView = document.getElementById('list-view');
    const listViewTab = document.getElementById('list-view-tab');
    const mapViewTab = document.getElementById('map-view-tab');
    const sideDrawer = document.getElementById('side-drawer');
    const topPath = document.getElementById('top-path');
    const bottomPath = document.getElementById('bottom-path');

    // Save the current scroll position
    util.saveScrollPosition(view === 'map' ? 'list' : 'map');

    mapViewTab.classList.remove('tab-active');
    listViewTab.classList.remove('tab-active');
    bottomPath.classList.remove('hidden');
    topPath.classList.remove('hidden');
    const footers = document.querySelectorAll('#footer');

    if (footers.length < 2) {
        return
    }

    const footer = footers[1];
    footer.classList.remove('hidden');

    if (view === 'map') {

        if (!mapLoaded) {
            mapLoaded = true;
            reloadMap();
        }

        mapView.classList.remove('hidden');
        listView.classList.add('hidden');
        mapViewTab.classList.add('tab-active');
        topPath.classList.add('hidden');
        bottomPath.classList.add('hidden');
        document.getElementById('getLocationBtn').classList.remove('opacity-0');
        footer.classList.add('hidden', 'lg:grid');
        sideDrawer.classList.remove('hidden');
    } else {
        mapView.classList.add('hidden');
        document.getElementById('getLocationBtn').classList.add('opacity-0');
        listView.classList.remove('hidden');
        sideDrawer.classList.add('hidden');
        listViewTab.classList.add('tab-active');

        // Check truncation for any cards that were created while list view was hidden
        if (cardsNeedingTruncationCheck.length > 0) {
            requestAnimationFrame(() => {
                cardsNeedingTruncationCheck.forEach(({ cardText, textWrapper, cardBody }) => {
                    util.isTruncated(cardText, textWrapper, cardBody);
                });
                cardsNeedingTruncationCheck = [];
            });
        }

        if (!fullyLoaded) {
            fetchData();
        }
    }
    
    // Restore the scroll position
    util.restoreScrollPosition(view);
    
    util.addQuery('v', view);
}

// Handle the popstate event to switch views when navigating with the browser's back/forward buttons
window.addEventListener('popstate', (event) => {
    if (event.state && event.state.v) {
        switchView(event.state.v);
    }
    if (event.state && (event.state.lt || event.state.ln)) {
        if (event.state.lt && event.state.ln && !isNaN(event.state.lt) && !isNaN(event.state.ln)) {
            updateView(event.state.lt, event.state.ln);
        }
    }

    if (event.state && event.state.z && !isNaN(event.state.z)) {
        updateZoom(event.state.z);
    }

    if (event.state && event.state.p) {
        getMarker(event.state.p);
    }

    updateInputs();
    
    if (event.state && event.state.path) {
        const params = util.getQueryParams();

        const newView = params['v'];
        const newLat = parseFloat(params['lt']);
        const newLng = parseFloat(params['ln']);
        const newZoom = parseInt(params['z'], 10);
        const newPlace = params['p'];

        // Compare and update only if there are changes
        if (newView) {
            switchView(newView);
        }
        if (!isNaN(newLat) && !isNaN(newLng) && (newLat && newLng)) {
            updateView(newLat, newLng);
        }
        if (!isNaN(newZoom) && newZoom) {
            updateZoom(newZoom);
        }
        if (newPlace) {
            getMarker(newPlace);
        }

        getFilterQuery();
        updateFilterUI();
    }
    forceFetchData();
});

function updateInputs() {
    const search = document.getElementById('search');
    const city = document.getElementById('city');
    const sort = document.getElementById('sort');

    const queryParams = util.getQueryParams();

    search.value = queryParams['q'] || '';
    sort.value = queryParams['s'] || '';
    city.value = queryParams['c'] || 'dynamic';
}

let map;
let mapFullyLoaded = false;

function initMap() {

    const params = util.getQueryParams();
    const lat = params['lt'];
    const long = params['ln'];
    const zoom = params['z'];
    const place = params['p'];

    map = L.map('map', {
        zoomControl: false,
        minZoom: 5,
        maxZoom: 20,
    }).setView([lat || 49.5897, long || 11.0120], zoom || 5);

    if (place && !isNaN(place)) {
        setTimeout(() => {
            getMarker(place);
        }, 800);
    }

    setLayer(util.isDarkMode()? 'streets-v2-dark' : 'streets-v2');
    saveMapData(map.getCenter().lat, map.getCenter().lng, map.getZoom());

    // Add the attribution control manually to the desired corner
    L.control.attribution({
        position: 'topleft'
    }).addTo(map);

    setTimeout(() => {
        mapFullyLoaded = true;
        fetchMapData();

        // Add event listener to fetch new data when the map is moved
        map.on('moveend', () => {
            saveMapData(map.getCenter().lat, map.getCenter().lng, map.getZoom());
        });

        map.on('zoomend', () => {
            const currentZoom = map.getZoom();
            handleMarkerVisibility(currentZoom);
            saveMapData(map.getCenter().lat, map.getCenter().lng, map.getZoom());
        });

        // Initialize city markers once map is ready
        displayCityMarkers();
    }, 700);
}

eventBus.on('theme:switch', (data) => {
    if (map) {
        setLayer(data.theme === 'dark' ? 'streets-v2-dark' : 'streets-v2');
    }
});

let currentLayer;
function setLayer(style) {
    if (currentLayer) {
        map.removeLayer(currentLayer);
    }

    // Create a MapTiler Layer inside Leaflet
    currentLayer = new L.maptiler.maptilerLayer({
        apiKey: mapsAPIKey,
        style,
        maxZoom: 20,
        attribution: `&copy; <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a>
            &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>`
    }).addTo(map);
}

const max_zoom = 10;
const detail_zoom = 14;
function handleMarkerVisibility(zoomLevel) {
    const zoomHint = document.getElementById('location-hint');

    if (userMarker) {
        userMarker.setOpacity(zoomLevel < max_zoom ? 0 : 1);
        userMarker.options.interactive = zoomLevel >= max_zoom;
    }

    Object.values(markers).forEach(({marker}) => {
        if (zoomLevel < detail_zoom) {
            const elements = document.getElementsByClassName('review-marker-name');
            Array.from(elements).forEach((el) => {
                el.classList.add('hidden');
            });
        } else {
            const elements = document.getElementsByClassName('review-marker-name');
            Array.from(elements).forEach((el) => {
                el.classList.remove('hidden');
            });
        }

        if (zoomLevel < max_zoom) {
            marker.setOpacity(0);
            marker.options.interactive = false;
            
            // Show zoom hint
            if (zoomHint) {
                zoomHint.innerHTML = t('map.zoomHint') + '<i class="fa-solid fa-magnifying-glass-plus"></i>';
                zoomHint.classList.remove('hidden');
            }
        } else {
            marker.setOpacity(1);
            marker.options.interactive = true;
            
            // Hide zoom hint when zoomed in enough
            if (zoomHint) {
                zoomHint.innerHTML = t('review.cta');
                if (selectedMarker && selectedMarker.id) {
                    zoomHint.classList.add('hidden');
                    selectMarker(selectedMarker.id);
                }
            }
        }
    });

    // Toggle city markers visibility opposite to review markers
    Object.values(cityMarkers).forEach((marker) => {
        if (!marker || !marker.marker) return;
        if (zoomLevel < max_zoom) {
            marker.marker.setOpacity(1);
            marker.marker.options.interactive = true;
        } else {
            marker.marker.setOpacity(0);
            marker.marker.options.interactive = false;
            if (marker.marker.closePopup) marker.marker.closePopup();
        }
    });
}

// Reload the map to fix the tiles not loading
function reloadMap() {
    if (map) {
        setTimeout(() => {
            map.invalidateSize();
        }, 10);
    }
}

// Display markers on the map
function displayMarkers(data) {
    for (const place of data) {
        if (!markers[place.reviewId]) {
            const marker = placeMarker(place);
            markers[place.reviewId] = { marker, place };
        } else {
            // Refresh icon with latest rating/name and preserve selection state
            const isSelected = selectedMarker && selectedMarker.id === place.reviewId;
            setMarkerSelected(place.reviewId, isSelected, place);
            markers[place.reviewId].place = place;
        }
    }

    handleMarkerVisibility(map.getZoom());
}

const loadingMarkers = {};
function getMarker(id, moveMap = false) {
    if (loadingMarkers[id]) {
        return;
    }

    if (!markers[id]) {
        loadingMarkers[id] = true;
        simpleGetRequest('/api/v1/reviews/map/' + id, 'btm-drawer-loader', (res) => handleMarkerFetch(res, moveMap));
        return;
    }
    selectMarker(id, moveMap);
}

function handleMarkerFetch(res, moveMap = false) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    const data = res.data;
    if (!data || data.length != 1) {
        showAlert(t('errors.contentNotFound'), 'error');
        return;
    }
    const id = data[0].reviewId;
    loadingMarkers[id] = false;
    if (!markers[data[0].reviewId]) {
        const place = data[0];
        const marker = placeMarker(place);
        markers[place.reviewId] = { marker, place };
    }

    if (selectedMarker && selectedMarker.id !== id) {
        resetMarker(selectedMarker.id);
    }

    selectMarker(id, moveMap);
}

let currentCity = null;
function updateView(lat, long, save = true) {
    map.setView([lat, long]);
    if (save) {
        saveMapData(lat, long, map.getZoom());
    }
}

function updateZoom(zoom, save = true) {
    map.setZoom(zoom);
    if (save) {
        saveMapData(map.getCenter().lat, map.getCenter().lng, map.getZoom());
    }
}

function saveMapData(lat, long, zoom) {
    const url = new URL(window.location);
    util.addQuery(['lt', 'ln', 'z'], [lat, long, zoom]);
    const city = getNearestCity(lat, long);

    if (city && (!currentCity || city.zip !== currentCity.zip)) {
        updateCity(city);
    }
}

let markers = {};
let selectedMarker = {
    marker: null,
    id: null
};

function selectMarker(id, moveMap = false) {
    if (!markers[id] || !markers[id].marker) {
        console.error('Marker ' + id + ' not found');
        return;
    }

    // Close any existing popups first
    if (selectedMarker && selectedMarker.id !== id) {
        setMarkerSelected(selectedMarker.id, false);
        resetMarker(selectedMarker.id);
    }

    const place = markers[id].place;
    const marker = markers[id].marker;
    
    setMarkerSelected(id, true);
    
    if (moveMap && marker && map) {
        map.setView(marker.getLatLng());
    }

    selectedMarker = {
        marker,
        id
    };

    getReviewInformation(place);
    
    util.addQuery('p', id);
}

function resetMarker(id) {
    if (id) {
        const tempMarker = markers[id].marker;
        tempMarker.closePopup();
        setMarkerSelected(id, false);
        clearReviewInformation();
    }
}

function removeMarkers(initialLoad = false) {
    if (!initialLoad) {
        if (selectedMarker && selectedMarker.id) {
            closeReview(selectedMarker.id);
        }
        for (const marker of Object.values(markers)) {
            marker.marker.remove();
        }
        markers = {};
    }
}

function closeReview(id) {
    clearReviewInformation();
    resetMarker(id);
    selectedMarker = null;
}

function clearReviewInformation() {
    const drawer = document.getElementById('btm-drawer');
    if (!drawer.classList.contains('open')) {
        document.getElementById('btm-drawer-close').classList.add('hidden');
    }
    document.getElementById('btm-drawer-location').classList.add('hidden');
    drawer.classList.remove('expanded-btm-drawer');

    // Remove the marker ID from the URL
    util.removeQuery('p');
    document.getElementById('location-hint').classList.remove('hidden');
    document.getElementById('location-details-short').classList.add('hidden');

    document.getElementById('location-tags-short').innerHTML = '';
    document.getElementById('location-name-short').innerHTML = 'None selected';
    document.getElementById('location-rating-short').innerHTML = '0.0';
    document.getElementById('location-price-short').innerHTML = '0€';
    document.getElementById('location-address-short').innerHTML = 'Select Location...';
    document.getElementById('location-address-short').href = '#';
    document.getElementById('location-rate-short').href = '#';
    document.getElementById('location-view-short').href = '#';
    document.getElementById('location-img').classList.add('hidden');
    document.getElementById('location-img-skeleton').classList.remove('hidden');

    document.getElementById('location-tags').innerHTML = '';
    document.getElementById('location-name').innerHTML = 'None selected';
    document.getElementById('location-rating').innerHTML = '0.0';
    document.getElementById('location-price').innerHTML = '0€';
    document.getElementById('location-address').innerHTML = 'Select Location...';
    document.getElementById('location-img').src = '';
    document.getElementById('location-img').alt = '';
    document.getElementById('location-opening-hours').textContent = '';
    document.getElementById('location-meat-types').innerHTML = '';
    document.getElementById('location-star-rating').innerHTML = '';
    document.getElementById('location-btn').href = '#';
    document.getElementById('location-btn').innerText = t('map.loading');
    document.getElementById('location-name').href = '#';
    document.getElementById('location-img-container').href = '#';
    document.getElementById('location-rate').href = '#';
    document.getElementById('location-address').href = '#';
}

function increaseMarker(id) {
    if (id) {

        markers[id].marker.setIcon(new L.Icon({
            iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
            shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
            iconSize: [35, 55],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        })
        );
    }
}

const marker = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

function computeRating(place) {
    if (typeof place.avgRating === 'number') return Number(place.avgRating);
    if (
        place.avgTaste !== undefined && place.avgSauce !== undefined &&
        place.avgIngredients !== undefined && place.avgValue !== undefined &&
        place.avgPresentation !== undefined && place.avgAmbiance !== undefined
    ) {
        const sum = place.avgTaste + place.avgSauce + place.avgIngredients + place.avgValue + place.avgPresentation + place.avgAmbiance;
        return sum / 6;
    }
    return undefined;
}

function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

function createReviewMarkerIcon(place, selected = false) {
    const ratingVal = computeRating(place);
    const ratingText =
        typeof ratingVal === 'number' && Number.isFinite(ratingVal) && ratingVal > 0
            ? ratingVal.toFixed(1)
            : '—';

    const safeName = escapeHtml(place?.name || '');
    const selectedClass = selected ? 'is-selected' : '';

    const html = `
        <div class="review-marker ${selectedClass}">
            <div class="review-marker-badge">
                <span class="review-marker-rating">${ratingText}</span>
            </div>
            <div class="review-marker-name" title="${safeName}">${safeName}</div>
        </div>
    `;

    return L.divIcon({
        html,
        className: 'review-marker-icon',
        iconSize: [48, 34],
        iconAnchor: [24, 29],      // bottom tip of the diamond
        popupAnchor: [0, -29],
    });
}

function setMarkerSelected(id, selected, nextPlace) {
    if (!markers[id]) return;
    const markerEntry = markers[id];
    const place = nextPlace || markerEntry.place;
    markerEntry.marker.setIcon(createReviewMarkerIcon(place, selected));
    markerEntry.marker.setZIndexOffset(selected ? 500 : 0);
}

function placeMarker(place) {
    if (!map || !place || !place.lat || !place.long) {
        return;
    }

    // Set initial interactivity based on zoom level
    const mapMarker = L.marker([place.lat, place.long], {
        icon: createReviewMarkerIcon(place),
        interactive: map.getZoom() >= 10,
        riseOnHover: true
    }).addTo(map);

    // Set initial visibility based on current zoom
    if (map.getZoom() < 10) {
        mapMarker.setOpacity(0);
    }

    mapMarker.on('click', () => {
        getMarker(place.reviewId);
    });
    
    mapMarker.on('popupclose', () => {
        if (selectedMarker && selectedMarker.id === place.reviewId) {
            clearReviewInformation();
            if (map.getZoom() >= max_zoom) {
                selectedMarker = null;
            }
        }
    });
    
    return mapMarker;
}

function handleMapData(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }
    displayMarkers(res.data);
}

const loadingReviewInfo = {};
function getReviewInformation(place) {
    if (places[place.reviewId]) {
        displayReviewInformation(places[place.reviewId]);
        return;
    }

    if (loadingReviewInfo[place.reviewId]) {
        return;
    }
    loadingReviewInfo[place.reviewId] = true;
    simpleGetRequest(`/api/v1/reviews/${place.reviewId}`, 'btm-drawer-loader', handleReviewInformation);
}

function handleReviewInformation(res) {
    loadingReviewInfo[res.id] = false;
    if (res.error) {
        handleErrors(res);
        return;
    }

    if (!res.data || res.data.length != 1) {
        console.error('No data found');
        return;
    }

    const place = res.data[0];

    if (!markers[place.reviewId]) {
        console.error('No marker found');
        return;
    }

    // Update marker icon to always show accurate rating and name (keep selection state)
    const isSelected = selectedMarker && selectedMarker.id === place.reviewId;
    setMarkerSelected(place.reviewId, isSelected, place);

    displayReviewInformation(place);
}

// Display review information in the drawer
function displayReviewInformation(place) {
    document.getElementById('btm-drawer-close').classList.remove('hidden');
    document.getElementById('btm-drawer').classList.add('expanded-btm-drawer');
    document.getElementById('btm-drawer-location').classList.remove('hidden');

    document.getElementById('location-hint').classList.add('hidden');
    document.getElementById('location-details-short').classList.remove('hidden');
    document.getElementById('location-name-short').innerHTML = place.name;
    document.getElementById('location-name').innerHTML = place.name;
    const avgRating = (place.avgTaste + place.avgSauce + place.avgIngredients + place.avgValue + place.avgPresentation + place.avgAmbiance) / 6;
    document.getElementById('location-rating-short').innerHTML = avgRating.toFixed(1);
    document.getElementById('location-rating').innerHTML = avgRating.toFixed(1);
    document.getElementById('location-price-short').innerHTML = place.price + '€';
    document.getElementById('location-price').innerHTML = place.price + '€';
    
    // Add like count display
    const likeCountShort = document.getElementById('location-likes-short');
    const likeCountLong = document.getElementById('location-likes');
    if (likeCountShort) {
        likeCountShort.innerHTML = `<i class="fa-solid fa-heart text-error"></i> ${place.likeCount || 0}`;
    }
    if (likeCountLong) {
        likeCountLong.innerHTML = `<i class="fa-solid fa-heart text-error"></i> ${place.likeCount || 0}`;
    }
    
    let address;
    let query;
    if (place.city_name != '' && place.city_name != null) {
        if (place.cityName && place.cityName != '' && place.cityName != null && place.cityName != place.city_name) {
            address = `${place.street} ${place.number}, ${place.zip} ${place.city_name} (${place.cityName})`;
            query = `${place.name}, ${place.street} ${place.number}, ${place.city_name}`;
        } else {
            address = `${place.street} ${place.number}, ${place.zip} ${place.city_name}`;
            query = `${place.name}, ${place.street} ${place.number}, ${place.zip} ${place.city_name}`;
        }
    } else {
        address = `${place.street} ${place.number}, ${place.zip}`;
        query = `${place.name}, ${place.street} ${place.number}, ${place.zip}`;
    }

    document.getElementById('location-address-short').innerHTML = address;
    document.getElementById('location-address').innerHTML = address;
    if (!place.locationUrl) {
        document.getElementById('location-address-short').href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);
        document.getElementById('location-address').href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(query);
    } else {
        document.getElementById('location-address-short').href = place.locationUrl;
        document.getElementById('location-address').href = place.locationUrl;
    }

    document.getElementById('location-rate-short').href = '/r/' + place.reviewId + '?modal=ratingModal';
    document.getElementById('location-view-short').href = '/r/' + place.reviewId;
    document.getElementById('location-rate').href = '/r/' + place.reviewId + '?modal=ratingModal';
    document.getElementById('location-btn').href = '/r/' + place.reviewId;
    document.getElementById('location-btn').innerText = t('map.view', { place: place.name });
    document.getElementById('location-name').href = '/r/' + place.reviewId;
    document.getElementById('location-img-container').href = '/r/' + place.reviewId;
    const longMeattypes = document.getElementById('location-meat-types');
    const meattypes = place.meatType;
    
    document.getElementById('location-img').src = place.images[0]?.url || '/img/placeholder.png';
    document.getElementById('location-img').alt = place.name;

    // Hide skeleton loader once image is loaded
    document.getElementById('location-img').addEventListener('load', () => {
        document.getElementById('location-img').classList.remove('hidden');
        document.getElementById('location-img-skeleton').classList.add('hidden');
    });

    longMeattypes.innerHTML = '';
    if (Array.isArray(meattypes)) {
        meattypes.forEach(type => {
            const span = document.createElement('span');
            span.classList.add('badge', 'badge-accent', 'text-gray-100', 'mb-2', 'min-w-fit');
            span.innerText = t('dropdown.' + type);
            longMeattypes.appendChild(span);
        });
    } else {
        const span = document.createElement('span');
        span.classList.add('badge', 'badge-accent', 'text-gray-100', 'mb-2', 'min-w-fit');
        span.innerText = meattypes;
        longMeattypes.appendChild(span);
    }

    const longOpeningHours = document.getElementById('location-opening-hours');
    const status = isOpenNow(place.openingHours);
    if (status.isOpen) {
        if (status.closingSoon) {
            longOpeningHours.textContent = t('review.closing');
            longOpeningHours.classList.add('text-yellow-500');
        } else {
            longOpeningHours.textContent = t('review.open');
            longOpeningHours.classList.add('text-green-500');
        }
    } else {
        longOpeningHours.textContent = t('review.closed');
        longOpeningHours.classList.add('text-red-500');
    }

    const starRating = document.getElementById('location-star-rating');
    starRating.innerHTML = getAsString(avgRating, 5);
    const badgeList = getTagNames(place);

    const shortTags = document.getElementById('location-tags-short');
    const longTags = document.getElementById('location-tags');
    shortTags.innerHTML = '';
    longTags.innerHTML = '';
    badgeList.forEach(tag => {
        const span = createBadge(tag, 'badge-accent');
        shortTags.appendChild(span);
        longTags.appendChild(span.cloneNode(true));
    });

    displaySidebarInformation(place);
}

// scroll to the position of the place in the sidebar and highlight it
function displaySidebarInformation(place) {
    const item = document.getElementById('review-list-' + place.id);

    if (item) {
        item.classList.add('border-secondary');
        item.classList.remove('border-transparent');
        item.scrollIntoView({ behavior: 'smooth', block: 'start', container: 'nearest' });
        setTimeout(() => {
            item.classList.remove('border-secondary');
            item.classList.add('border-transparent');
        }, 2000);
    } else {
        showAlert(t('errors.itemNotFound'), 'error');
    }
}

// check if a place is open now based on its opening hours
function isOpenNow(hours) {
    const now = new Date();
    const day = now.toLocaleString('en-us', { weekday: 'long' }).toLowerCase();
    const currentTime = now.getHours() * 60 + now.getMinutes();

    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayDay = yesterday.toLocaleString('en-us', { weekday: 'long' }).toLowerCase();
    if (hours[day]) {
        for (const slot of hours[day]) {
            const [openHour, openMinute] = slot.open.split(':').map(Number);
            const [closeHour, closeMinute] = slot.close.split(':').map(Number);
            const openTime = openHour * 60 + openMinute;
            let closeTime = closeHour * 60 + closeMinute;

            // If closing time is earlier than opening time, it means it closes after midnight
            if (closeTime < openTime) {
                closeTime += 24 * 60;
            }

            if (currentTime >= openTime && currentTime < closeTime) {
                return { isOpen: true, closingSoon: (closeTime - currentTime) <= 60 };
            }
        }
    }

    if (hours[yesterdayDay]) {
        for (const slot of hours[yesterdayDay]) {
            const [openHour, openMinute] = slot.open.split(':').map(Number);
            const [closeHour, closeMinute] = slot.close.split(':').map(Number);
            const openTime = openHour * 60 + openMinute;
            let closeTime = closeHour * 60 + closeMinute;

            // Only consider cases where the place closes after midnight
            if (closeTime < openTime) {
                closeTime += 24 * 60; 
                const currentTimePlus24 = currentTime + 24 * 60;
                
                if (currentTime < (closeTime - 24 * 60)) {
                    return { isOpen: true, closingSoon: ((closeTime - 24 * 60) - currentTime) <= 60 };
                }
            }
        }
    }

    return { isOpen: false };
}

// force fetch map data for map view
function forceFetchMapData(initialLoad = false) {
    removeMarkers(initialLoad);
    fetchMapData();
}

// fetch map data based on current map bounds
function fetchMapData() {
    if (!mapFullyLoaded) {
        return;
    }

    const filter = { ...getFilterQuery(), isMapQuery: true };
    filter.bbox = map.getBounds().toBBoxString();

    const headers = {
        'Content-Type': 'application/json',
        'data': JSON.stringify(filter)
    }

    fetchRequest('GET', '/api/v1/reviews/map', null, headers, 'btm-drawer-loader', handleMapData, true, false);
}

// Find the nearest city based on latitude and longitude for map view
function getNearestCity(lat, long) {
    if (!cities || cities.length === 0) {
        console.error('No cities found!');
        return;
    }

    const city = cities.reduce((prev, curr) => {
        const prevDist = distance(lat, long, prev.latitude, prev.longitude);
        const currDist = distance(lat, long, curr.latitude, curr.longitude);
        return prevDist < currDist ? prev : curr;
    });

    return city;
}

// Haversine formula to calculate distance between two lat/long points in meters
function distance(lat1, long1, lat2, long2) {
    const R = 6371e3;
    const φ1 = lat1 * Math.PI / 180;
    const φ2 = lat2 * Math.PI / 180;
    const Δφ = (lat2 - lat1) * Math.PI / 180;
    const Δλ = (long2 - long1) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c;
}

// update city display and fetch data if city changes
function updateCity(city) {
    document.getElementById('city-name').innerHTML = city.cityName + ' (' + city.zip + ')';
    document.getElementById('city-name2').innerHTML = city.cityName + ' (' + city.zip + ')';
    document.getElementById('city-name3').innerHTML = city.cityName + ' (' + city.zip + ')';

    if (document.getElementById('city').value == 'dynamic') {
        filter.city = 'dynamic';
        filter.zip = city.zip;
        updateQuery();
    }

    if (!currentCity || currentCity.cityName !== city.cityName) {
        forceFetchData();
    }

    currentCity = city;
}

// Function to format sort strings
function formatSortString(sort) {
    return t('dropdown.' + sort);
}

// force fetch data for list view
function forceFetchData(initialLoad = false) {
    fullyLoaded = false;
    places = {};
    listPage = 1;
    clearContent();
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    fetchData();
    forceFetchMapData(initialLoad);
}

// reset filter to default values
export function resetFilters() {
    filter.city = 'dynamic';
    filter.sort = '';
    filter.query = '';
    filter.filters = [];
    filter.meat = [];
    filter.price = -1;
    filter.star = 0;
    filter.openAt = undefined;
    filter.ratingWeights = undefined;

    updateQuery();
    updateFilterUI();
    forceFetchData();
}

// save filter object to URL query parameters
function updateQuery() {
    const url = new URL(window.location);
    if (filter.query && filter.query !== '') {
        url.searchParams.set('q', filter.query);
    } else {
        url.searchParams.delete('q');
    }

    if (filter.city && filter.city !== 'dynamic' && filter.city !== '') {
        url.searchParams.set('c', filter.city);
    } else {
        url.searchParams.delete('c');
    }

    if (filter.sort && filter.sort !== '') {
        url.searchParams.set('s', filter.sort);
    } else {
        url.searchParams.delete('s');
    }

    if (filter.filters.length > 0) {
        url.searchParams.set('f', filter.filters.join(','));
    } else {
        url.searchParams.delete('f');
    }

    if (filter.meat.length > 0) {
        url.searchParams.set('m', filter.meat.join(','));
    } else {
        url.searchParams.delete('m');
    }

    if (filter.price != undefined && filter.price > -1) {
        url.searchParams.set('pr', filter.price);
    } else {
        url.searchParams.delete('pr');
    }

    if (filter.star && filter.star !== '' || filter.star > 24) {
        url.searchParams.set('st', filter.star);
    } else {
        url.searchParams.delete('st');
    }

    if (filter.zip && filter.zip !== '') {
        url.searchParams.set('zip', filter.zip);
    } else {
        util.removeQuery('zip')
    }

    if (filter.openAt && filter.openAt.day && filter.openAt.time) {
        url.searchParams.set('ohd', filter.openAt.day);
        url.searchParams.set('oht', filter.openAt.time);
    } else {
        url.searchParams.delete('ohd');
        url.searchParams.delete('oht');
    }

    // Rating weights
    if (filter.ratingWeights) {
        const w = filter.ratingWeights;
        const sum = Number(w.taste || 0) + Number(w.sauce || 0) + Number(w.ingredients || 0) + Number(w.presentation || 0) + Number(w.value || 0) + Number(w.ambiance || 0);
        if (Number.isFinite(sum) && sum > 0) {
            url.searchParams.set('rw', [w.taste, w.sauce, w.ingredients, w.presentation, w.value, w.ambiance].join(','));
        } else {
            url.searchParams.delete('rw');
        }
    } else {
        url.searchParams.delete('rw');
    }

    window.history.pushState({ path: url.toString() }, 'Updated filters to: ' + filter.query + filter.city + filter.sort + filter.filters + filter.meat + filter.price + filter.star + filter.zip , url);
}

// build filter object from URL query parameters
function getFilterQuery() {
    const queryParams = util.getQueryParams();
    const city = queryParams['c'] || 'dynamic';
    const zip = queryParams['zip'] || '';
    const sort = queryParams['s'] || '';
    const query = queryParams['q'] || '';
    const filters = queryParams['f'] || '';
    const meat = queryParams['m'] || '';
    const price = queryParams['pr'] || -1;
    const star = queryParams['st'] || 0;

    const openAtDay = queryParams['ohd'] || '';
    const openAtTime = queryParams['oht'] || '';
    const ratingWeightsRaw = queryParams['rw'] || '';

    filter.city = decodeURIComponent(city);
    filter.zip = zip;
    filter.sort = sort;
    filter.query = decodeURIComponent(query);
    filter.filters = filters ? decodeURIComponent(filters).split(',') : [];
    filter.meat = meat ? decodeURIComponent(meat).split(',') : [];
    filter.price = price ? parseInt(price, 10) : -1;
    filter.star = star ? parseInt(star, 10) : 0;

    if (openAtDay && openAtTime) {
        filter.openAt = { day: openAtDay, time: openAtTime };
    } else {
        filter.openAt = undefined;
    }

    const parts = typeof ratingWeightsRaw === 'string' && ratingWeightsRaw.length > 0
        ? ratingWeightsRaw.split(',')
        : [];
    const getPart = (idx, fallback) => {
        const v = Number(parts[idx]);
        return Number.isFinite(v) ? v : fallback;
    };

    const weights = {
        taste: getPart(0, 1),
        sauce: getPart(1, 1),
        ingredients: getPart(2, 1),
        presentation: getPart(3, 1),
        value: getPart(4, 1),
        ambiance: getPart(5, 1),
    };

    const sum = weights.taste + weights.sauce + weights.ingredients + weights.presentation + weights.value + weights.ambiance;
    filter.ratingWeights = sum > 0 ? weights : undefined;

    calcIndicator();
    return filter;
}

// calculate number of active filters
function calcIndicator() {
    let count = 0;
    const indicator = document.getElementById('filter-indicator');

    if (filter.query && filter.query !== '') {
        count += 1;
    }

    if (filter.city && filter.city !== 'dynamic' && filter.city !== 'all' && filter.city !== '') {
        count += 1;
    }

    if (filter.price != undefined && filter.price > -1) {
        count += 1;
    }

    if (filter.star != undefined && filter.star > 0) {
        count += 1;
    }

    if (filter.filters.length > 0) {
        count += filter.filters.length;
    }

    if (filter.meat.length > 0) {
        count += filter.meat.length;
    }

    if (filter.openAt && filter.openAt.day && filter.openAt.time) {
        count += 1;
    }

    if (filter.ratingWeights) {
        const w = filter.ratingWeights;
        const anyNonDefault = [w.taste, w.sauce, w.ingredients, w.presentation, w.value, w.ambiance].some(v => Number(v) !== 1);
        if (anyNonDefault) {
            count += 1;
        }
    }

    if (count > 0) {
        indicator.classList.remove('hidden');
        indicator.innerText = count;
    } else {
        indicator.classList.add('hidden');
    }
}

function updateFilterUI() {
    const city = document.getElementById('city');
    const sort = document.getElementById('sort');
    const search = document.getElementById('search');
    const star = document.getElementById('filter-stars');

    const advancedEnabled = document.getElementById('advanced-hours-enabled');
    const advancedDay = document.getElementById('advanced-hours-day');
    const advancedTime = document.getElementById('advanced-hours-time');
    const advancedHoursCollapse = document.getElementById('advanced-hours-collapse');

    city.value = filter.city || 'dynamic';

    // Check if the city is in the list of options
    if (!Array.from(city.options).some(option => option.value === filter.city) && filter.city !== 'dynamic' && filter.city !== 'all') {
        city.value = 'dynamic';
        filter.city = 'dynamic';
    }

    sort.value = filter.sort || '';
    search.value = filter.query || '';
    star.value = filter.star || 0;

    if (advancedEnabled && advancedDay && advancedTime) {
        const isEnabled = !!(filter.openAt && filter.openAt.day && filter.openAt.time);
        advancedEnabled.checked = isEnabled;
        if (isEnabled) {
            setCollapseOpen(advancedHoursCollapse, true);
            advancedDay.value = filter.openAt.day;
            advancedTime.value = filter.openAt.time;
        }
    }

    const weights = filter.ratingWeights || {
        taste: 1,
        sauce: 1,
        ingredients: 1,
        presentation: 1,
        value: 1,
        ambiance: 1,
    };

    document.getElementById('weight-taste').value = weights.taste;
    document.getElementById('weight-sauce').value = weights.sauce;
    document.getElementById('weight-ingredients').value = weights.ingredients;
    document.getElementById('weight-presentation').value = weights.presentation;
    document.getElementById('weight-value').value = weights.value;
    document.getElementById('weight-ambiance').value = weights.ambiance;

    if (star.value < 0 || star.value > 100) {
        star.value = 0;
        filter.star = 0;
    }

    document.querySelectorAll('.sort-option').forEach(option => {
        option.classList.remove('bg-primary');
    });

    if (sort.value !== '') {
        try {
            document.getElementById('sort-' + sort.value).classList.add('bg-primary');
            document.getElementById('sort-' + sort.value).classList.add('text-gray-100');
            document.getElementById('sort-' + sort.value + '-2').classList.add('bg-primary');
            document.getElementById('sort-' + sort.value + '-2').classList.add('text-gray-100');
            document.getElementById('sort-text').innerHTML = '<i class="fa-solid fa-right-left"></i>' + formatSortString(sort.value);
            document.getElementById('sort-text-2').innerHTML = '<i class="fa-solid fa-arrow-down-wide-short"></i>' + formatSortString(sort.value);
        } catch(e) {
            console.error('Error updating filter selection', e);
        }
    }

    if (filter.filters.length > 0) {
        filter.filters.forEach(f => {
            try {
                const checkbox = document.getElementById(f);
                checkbox.checked = true;
                updateSelection(checkbox);
            } catch(e) {
                filter.filters.splice(filter.filters.indexOf(f), 1);
                console.error('Error updating filter selection', e);
            }
        });
    }

    if (filter.meat.length > 0) {
        filter.meat.forEach(m => {
            try {
                const checkbox = document.getElementById(m);
                checkbox.checked = true;
                updateSelection(checkbox);
            } catch(e) {
                filter.meat.splice(filter.meat.indexOf(m), 1);
                console.error('Error updating filter selection', e);
            }
        });
    }

    if (filter.price && (filter.price < -1 || filter.price > 2)) {
        filter.price = -1;
    }

    if (filter.price !== -1 && filter.price !== undefined) {
        try {
            document.getElementById('price-' + filter.price).classList.add('btn-primary');
        } catch(e) {
            console.error('Error updating filter selection', e);
            showAlert('The price option ' + filter.price + ' was not found.', 'error');
        }
    }

    calcIndicator();
    updateQuery();
}

// Get Review Data from the API based on filters
function fetchData() {
    if (!loaded || fullyLoaded) {
        return;
    }
    
    showSkeleton();

    const filter = { ...getFilterQuery(), isMapQuery: false };
    // Ensure list requests never carry a bbox filter.
    // (bbox is only meaningful for the map endpoint)
    delete filter.bbox;
    filter.page = listPage;
    filter.limit = 10;
    const headers = {
        'Content-Type': 'application/json',
        'data': JSON.stringify(filter)
    }

    fetchRequest('GET', '/api/v1/reviews', null, headers, 'btm-drawer-loader', handleData, true);
}

function handleData(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    listPage += 1;
 
    if (res.page * 10 >= res.total) {
        fullyLoaded = true;
    }

    const length = res.total >= 150 ? '150+' : res.total;
    if (length != 1) {
        document.getElementById('searchBtn').innerHTML = t('map.search', { count: length });
    } else {
        document.getElementById('searchBtn').innerHTML = t('map.searchOne');
    }

    for (const place of res.data) {
        createListing(place);
    }

    hideSkeleton();
}

function clearContent() {
    // Clear the truncation check queue
    cardsNeedingTruncationCheck = [];
    
    const content = document.getElementById('content');
    for (let i = content.children.length - 1; i > 0 ; i--) {
        content.children[i].remove();
    }
    // Clear review list but keep skeleton
    const reviewList = document.getElementById('reviewList');
    const skeleton = document.getElementById('reviewSkeleton');
    const drawerReviewList = document.getElementById('drawer-review-list');
    const drawerSkeleton = document.getElementById('drawer-review-skeleton');
    
    // Remove all children except skeleton
    while (reviewList.firstChild) {
        if (reviewList.firstChild !== skeleton && drawerReviewList.firstChild !== drawerSkeleton) {
            drawerReviewList.removeChild(drawerReviewList.firstChild);
            reviewList.removeChild(reviewList.firstChild);
        }
        // If we've reached the skeleton, skip to next
        if (reviewList.firstChild === skeleton) {
            break;
        }
    }
}

function hideSkeleton() {
    const skeleton = document.getElementById('skeleton');
    const btmDrawerSkeleton = document.getElementById('reviewSkeleton');
    const drawerSkeleton = document.getElementById('drawer-review-skeleton');

    if (skeleton) {
        skeleton.classList.add('hidden')
    }

    if (fullyLoaded) {
        drawerSkeleton.classList.add('hidden');
        btmDrawerSkeleton.classList.add('hidden');
    }
}

function showSkeleton() {
    const skeleton = document.getElementById('skeleton');
    const btmDrawerSkeleton = document.getElementById('reviewSkeleton');
    const drawerSkeleton = document.getElementById('drawer-review-skeleton');

    if (skeleton) {
        skeleton.classList.remove('hidden')
    }
    btmDrawerSkeleton.classList.remove('hidden');
    drawerSkeleton.classList.remove('hidden');
}

let places = {};
let cardsNeedingTruncationCheck = [];

export function resetRatingWeights() {
    filter.ratingWeights = {
        taste: 1,
        sauce: 1,
        ingredients: 1,
        presentation: 1,
        value: 1,
        ambiance: 1,
    }

    updateFilterUI();
    updateQuery();
}

util.registerTriggerFunction('ratingCalcModal', (data) => {
    return showRatingCalculationModal(data);
});

function showRatingCalculationModal(info) {
    if (!info) {
        return false;
    }

    const content = document.getElementById('rating-calc-content');
    content.replaceChildren();
    const isWeighted = weightsEnabled();

    const title = document.createElement('div');
    title.classList.add('font-semibold');
    title.textContent = info?.name ? String(info.name) : '';
    content.appendChild(title);

    const values = {
        taste: info.avgTaste,
        sauce: info.avgSauce,
        ingredients: info.avgIngredients,
        presentation: info.avgPresentation,
        value: info.avgValue,
        ambiance: info.avgAmbiance,
    };

    const weights = filter.ratingWeights || {
        taste: 1,
        sauce: 1,
        ingredients: 1,
        presentation: 1,
        value: 1,
        ambiance: 1,
    };

    if (!info.totalRatings || info.totalRatings === 0) {
        const no = document.createElement('div');
        no.classList.add('mt-2', 'badge', 'badge-warning');
        no.textContent = t('review.noRating');
        content.appendChild(no);
        return;
    }

    const note = document.createElement('div');
    note.classList.add('mt-2', 'text-sm', 'opacity-70');
    note.textContent = isWeighted ? t('review.weightedLabel') : t('review.unweightedLabel');
    content.appendChild(note);

    const wrap = document.createElement('div');
    wrap.classList.add('overflow-x-auto', 'mt-3');
    const table = document.createElement('table');
    table.classList.add('table', 'table-sm');
    wrap.appendChild(table);

    const thead = document.createElement('thead');
    const headRow = document.createElement('tr');
    ['review.category', 'review.value', isWeighted ? 'review.weight' : null, isWeighted ? 'review.contribution' : null]
        .filter(Boolean)
        .forEach((k) => {
            const th = document.createElement('th');
            th.textContent = t(k);
            headRow.appendChild(th);
        });
    thead.appendChild(headRow);
    table.appendChild(thead);

    const tbody = document.createElement('tbody');

    const ratings = [
        { key: 'taste', label: t('rating.taste') },
        { key: 'sauce', label: t('rating.sauce') },
        { key: 'ingredients', label: t('rating.ingredients') },
        { key: 'presentation', label: t('rating.appearance') },
        { key: 'value', label: t('rating.value') },
        { key: 'ambiance', label: t('rating.ambiance') },
    ];

    let weightedRatings = 0;
    let weightSum = 6;
    if (isWeighted) {
        weightSum = weights.taste + weights.sauce + weights.ingredients + weights.presentation + weights.value + weights.ambiance;
    }

    for (const rating of ratings) {
        const ratingValue = values[rating.key];
        const tr = document.createElement('tr');

        const tdLabel = document.createElement('td');
        tdLabel.textContent = rating.label;
        tr.appendChild(tdLabel);

        const tdVal = document.createElement('td');
        tdVal.textContent = ratingValue.toFixed(1);
        tr.appendChild(tdVal);

        if (isWeighted) {
            const weight = weights[rating.key];
            const contribution = ratingValue * weight;
            weightedRatings += contribution;

            const tdW = document.createElement('td');
            tdW.textContent = String(weight);
            tr.appendChild(tdW);

            const tdC = document.createElement('td');
            tdC.textContent = contribution.toFixed(1);
            tr.appendChild(tdC);
        } else {
            weightedRatings += ratingValue;
        }

        tbody.appendChild(tr);
    }

    table.appendChild(tbody);
    content.appendChild(wrap);

    const computedValue = weightSum > 0 ? (weightedRatings / weightSum) : 0;

    const summary = document.createElement('div');
    summary.classList.add('mt-3', 'text-sm');

    const line1 = document.createElement('div');
    line1.classList.add('font-semibold');
    line1.textContent = `${t('review.result')}: ${computedValue.toFixed(1)}`;
    summary.appendChild(line1);

    const displayed = Number.isFinite(Number(info?.avgRating)) ? Number(info.avgRating) : computedValue;
    const line2 = document.createElement('div');
    line2.classList.add('opacity-70');
    line2.textContent = `${t('review.displayed')}: ${Number(displayed).toFixed(1)}`;
    summary.appendChild(line2);

    content.appendChild(summary);
}

// Create the listing card for a rated place
function createListing(info) {

    if (places[info.reviewId]) {
        return;
    }

    places[info.reviewId] = info;

    // Create the card element
    const card = document.createElement('div');
    card.classList.add('card', 'lg:card-side', 'bg-base-100', 'shadow-xl', 'mb-10', 'mx-10', 'relative', 'flex', 'flex-col', 'lg:flex-row');

    // Create the card body & title
    const cardBody = document.createElement('div');
    cardBody.classList.add('card-body', 'lg:h-72', 'w-full', 'p-4', 'pb-5');
    const cardTitle = document.createElement('a');
    cardTitle.classList.add('card-title');
    cardTitle.href = `/r/${info.reviewId}`;
    cardTitle.style.cursor = 'pointer';
    const cardTitleEl = document.createElement('span');
    cardTitleEl.classList.add('lg:text-2xl', 'font-bold', 'text-md');
    cardTitleEl.innerText = info.name;
    cardTitle.appendChild(cardTitleEl);
    
    // Create the badges
    const badgeWrapper = document.createElement('div');
    badgeWrapper.classList.add('flex', 'flex-wrap', 'justify-between', 'items-center');
    const badges = document.createElement('div');
    badges.classList.add('cursor-pointer', 'flex', "w-full", 'gap-1', 'items-center', 'overflow-x-auto', 'overflow-y-hidden', 'whitespace-nowrap', 'max-w-[calc(100%-4.5rem)]');
    badgeWrapper.appendChild(badges);
    cardBody.appendChild(badgeWrapper);
    cardBody.appendChild(cardTitle)

    const openingHours = document.createElement('p');
    const smallOpeningHours = document.createElement('p');
    openingHours.classList.add('font-normal', 'hidden', 'lg:block')
    const status = isOpenNow(info.openingHours);
    if (status.isOpen) {
        if (status.closingSoon) {
            openingHours.textContent = t('review.closing');
            openingHours.classList.add('text-yellow-500');
            smallOpeningHours.textContent = t('review.closing');
            smallOpeningHours.classList.add('text-yellow-500', 'max-w-1/4', 'overflow-y-auto', 'whitespace-nowrap', 'overflow-x-hidden');
        } else {
            openingHours.textContent = t('review.open');
            openingHours.classList.add('text-green-500');
            smallOpeningHours.textContent = t('review.open');
            smallOpeningHours.classList.add('text-green-500');
        }
    } else {
        openingHours.textContent = t('review.closed');
        openingHours.classList.add('text-red-500');
        smallOpeningHours.textContent = t('review.closed');
        smallOpeningHours.classList.add('text-red-500');
    }
    cardTitle.appendChild(openingHours);

    const cardLocation = document.createElement('a');
    if (!info.locationUrl) {
        cardLocation.href = `https://www.google.com/maps/search/?api=1&query=${info.latitude},${info.longitude}`;
    } else {
        cardLocation.href = info.locationUrl;
    }
    if (info.city_name != '' && info.city_name != null) {
        if (info.city_name == info.cityName) {
            cardLocation.innerHTML = `<i class="fa-solid fa-location-dot"></i> ${info.street} ${info.number}, ${info.city_name}`;
        } else {
            cardLocation.innerHTML = `<i class="fa-solid fa-location-dot"></i> ${info.street} ${info.number}, ${info.city_name} ${info.cityName}`;
        }
    } else {
        if (info.zip == '' || info.zip == null) {
            cardLocation.innerHTML = `<i class="fa-solid fa-location-dot"></i> ${info.street} ${info.number}`;
        } else {
            cardLocation.innerHTML = `<i class="fa-solid fa-location-dot"></i> ${info.street} ${info.number}, ${info.zip}`;
        }
    }
    cardBody.appendChild(cardLocation);

    const textWrapper = document.createElement('div');
    textWrapper.classList.add('flex', 'flex-col', 'gap-2', 'mb-2');
    const cardText = document.createElement('p');
    cardText.innerText = info.text[locale] || info.text['en'] || info.text[info.text.original] || '';
    cardText.classList.add('line-clamp');
    textWrapper.appendChild(cardText);
    cardBody.appendChild(textWrapper);

    // Only check truncation if list view is visible, otherwise defer it
    const listView = document.getElementById('list-view');
    if (listView && !listView.classList.contains('hidden')) {
        util.isTruncated(cardText, textWrapper, cardBody);
    } else {
        // Store reference for later truncation check
        cardsNeedingTruncationCheck.push({ cardText, textWrapper, cardBody });
    }

    // Create the static rating
    const ratingWrapper = document.createElement('div');
    ratingWrapper.classList.add('mt-auto');
    const rating = document.createElement('a');
    rating.classList.add('h-8', 'inline-flex', 'items-center')
    const avgRating = info.avgTaste + info.avgSauce + info.avgIngredients + info.avgValue + info.avgPresentation + info.avgAmbiance;
    const fallbackRatingValue = avgRating / 6;
    const ratingValue = Number.isFinite(Number(info.avgRating)) ? Number(info.avgRating) : fallbackRatingValue;

    if (ratingValue == 0) {
        const badge = document.createElement('div');
        badge.classList.add('badge', 'badge-warning', 'mr-2', 'p-3');
        badge.innerText = t('review.noRating');
        rating.appendChild(badge);
    } else {
        const ratingValueEl = document.createElement('span');
        ratingValueEl.classList.add('text-2xl', 'font-bold', 'mr-2', 'text-primary', 'hidden', 'lg:block');
        ratingValueEl.innerText = ratingValue.toFixed(1);
        rating.appendChild(ratingValueEl);
        const ratingValueDupe = ratingValueEl.cloneNode(true);
        ratingValueDupe.classList.remove('hidden', 'lg:block');
        ratingValueDupe.classList.add('block', 'lg:hidden');
        cardTitle.insertBefore(ratingValueDupe, cardTitle.firstChild);
        rating.href = `/r/${info.reviewId}?modal=ratingModal`;
        rating.appendChild(getAsElement(ratingValue, 5));

        if (weightsEnabled()) {
            const weightedLabel = document.createElement('span');
            weightedLabel.classList.add('text-xs', 'opacity-70', 'ml-2', 'hidden', 'lg:inline');
            weightedLabel.textContent = t('review.weightedShort');
            rating.appendChild(weightedLabel);
        }

        const infoBtn = document.createElement('button');
        infoBtn.type = 'button';
        infoBtn.classList.add('btn', 'btn-ghost', 'btn-circle', 'btn-xs', 'ml-1');
        const icon = document.createElement('i');
        icon.classList.add('fa-solid', 'fa-circle-info', 'text-lg', 'text-secondary');
        infoBtn.appendChild(icon);
        infoBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            util.showModal('ratingCalcModal', info);
        });
        rating.appendChild(infoBtn);
    }

    ratingWrapper.appendChild(rating);
    cardBody.appendChild(ratingWrapper);

    // Check if the listing is less than a week old
    const listingDate = new Date(info.createdAt);
    const currentDate = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(currentDate.getDate() - 7);

    if (listingDate > oneWeekAgo) {
        const indicator = document.createElement('div');
        indicator.classList.add('indicator');
        const newBadge = document.createElement('span');
        newBadge.classList.add('indicator-item', 'badge', 'badge-warning');
        newBadge.innerText = t('dev.new');
        badges.appendChild(newBadge);
    }

    // Create city badge
    if (info.city_name != '' && info.city_name != null) {
        const cityBadge = document.createElement('span');
        cityBadge.classList.add('badge', 'badge-primary', 'cursor-pointer', 'hover:opacity-90', 'transition-all', 'duration-200');  
        cityBadge.innerHTML = '<i class="fa-solid fa-city"></i>' + info.cityName;
        cityBadge.title = `Filter by ${info.cityName}`;
        
        cityBadge.addEventListener('mouseover', () => {
            cityBadge.classList.add('scale-105');
        });
        
        cityBadge.addEventListener('mouseout', () => {
            cityBadge.classList.remove('scale-105');
        });
        
        cityBadge.onclick = (e) => {
            e.stopPropagation();
            
            // Add click animation
            cityBadge.classList.add('animate-pulse');
            setTimeout(() => {
                cityBadge.classList.remove('animate-pulse');
            }, 500);
            
            if (filter.city != info.cityName) {
                document.getElementById('city').value = info.cityName;
                filter.city = info.cityName;
                // Provide zip as a backend fallback.
                filter.zip = info.zip || cityNameToZip[info.cityName] || filter.zip;
            } else {
                document.getElementById('city').value = 'dynamic';
                filter.city = 'dynamic';
                // Keep the last known dynamic zip if available.
                if (currentCity?.zip) {
                    filter.zip = currentCity.zip;
                }
            }

            filterUpdate();
        }
        badges.appendChild(cityBadge);
    }

    const badgeList = getTags(info, (text, id) => {
        if (id != 'cheap') {
            const checkbox = document.getElementById(id);
            checkbox.checked = !checkbox.checked;
            updateSelection(checkbox);
        } else {
            priceUpdate(0);
        }
    });

    badgeList.forEach(badge => {
        badges.appendChild(badge);
    });

    const btmWrapper = document.createElement('div');
    btmWrapper.classList.add('w-full', 'inline-flex', 'initial', 'lg:absolute', 'lg:bottom-5', 'lg:right-5', 'lg:w-fit', 'gap-2');
    
    // Like count badge
    const likeCount = document.createElement('span');
    likeCount.classList.add('text-lg', 'font-bold', 'px-2', 'p-1', 'bg-secondary', 'text-gray-100', 'rounded-lg', 'flex', 'items-center', 'gap-1');
    likeCount.innerHTML = `<i class="fa-solid fa-heart text-error"></i> ${info.likeCount || 0}`;
    
    const price = document.createElement('span');
    price.classList.add('text-lg', 'font-bold', 'px-2', 'p-1', 'ml-auto', 'bg-primary', 'text-gray-100', 'rounded-lg', 'w-17', 'text-center');
    price.innerText = info.price + ' €';
    smallOpeningHours.classList.add('lg:hidden', 'mt-3')
    btmWrapper.appendChild(smallOpeningHours);
    btmWrapper.appendChild(likeCount);
    badgeWrapper.appendChild(price);
    cardBody.appendChild(btmWrapper);

    // Create the card actions
    const cardActions = document.createElement('div');
    cardActions.classList.add('card-actions', 'mr-0', 'ml-auto');
    const mapButton = document.createElement('a');
    mapButton.classList.add('btn', 'btn-secondary', 'text-gray-100');
    mapButton.innerHTML = '<i class="fa-solid fa-map-location-dot"></i>';
    if (!info.locationUrl) {
        mapButton.href = `https://www.google.com/maps/search/?api=1&query=${info.latitude},${info.longitude}`;
    } else {
        mapButton.href = info.locationUrl;
    }
    cardActions.appendChild(mapButton);
    const moreInfoButton = document.createElement('a');
    moreInfoButton.classList.add('btn', 'btn-primary');
    moreInfoButton.innerText = t('review.view');
    moreInfoButton.href = `/r/${info.reviewId}`;
    cardActions.appendChild(moreInfoButton);
    btmWrapper.appendChild(cardActions);
    
    // Create the image figure
    const figure = document.createElement('figure');
    figure.classList.add('lg:w-64', 'h-52','lg:max-h-72', 'lg:h-72', 'overflow-y-hidden', 'fit');

    // Create the skeleton loader
    const skeleton = document.createElement('div');
    skeleton.classList.add('skeleton', 'h-80', 'lg:h-72', 'lg:w-64', 'w-full');
    figure.appendChild(skeleton);

    // Create the anchor element to wrap the image
    const imgLink = document.createElement('a');
    imgLink.style.display = 'none'
    imgLink.href = `/r/${info.reviewId}`;
    const img = document.createElement('img');
    img.src = info.images[0]?.url || '/img/placeholder.png';
    img.alt = 'Döner Pic';
    img.style.display = 'none';

    img.addEventListener('load', () => {
        skeleton.style.display = 'none';
        img.style.display = 'block';
        imgLink.style.display = 'block';
    });

    imgLink.appendChild(img);
    figure.appendChild(imgLink);
    card.appendChild(figure);
    card.appendChild(cardBody);

    document.getElementById('content').appendChild(card);
    createMapListing(info);
}

function createMapListing(review) {
    createReviewCard(review, 'drawer-review-list', 'drawer-review-skeleton', () => getMarker(review.reviewId, true));
    createReviewCard(review, 'reviewList', 'reviewSkeleton', () => getMarker(review.reviewId, true));
}


export function requestLocation(force = false, initialLoad = false) {
    // Store initialLoad state for later use when position is received
    initalPositionLoad = initialLoad;
    
    // If browser doesn't support geolocation
    if (!navigator.geolocation) {
        showAlert("Your browser doesn't support geolocation.", "error");
        return;
    }
    
    // Check if we already have permission via the Permissions API
    if (navigator.permissions && navigator.permissions.query) {
        navigator.permissions.query({ name: 'geolocation' }).then(result => {
            if (result.state === 'granted' || result.state === 'prompt') {
                // We already have permission or browser will prompt, directly request coordinates
                getUserCoordinates();
            } else if (result.state === 'denied' && force) {
                const browser = detectBrowser();
                const error = {
                    code: 1
                }
                showLocationError({ error });
                showBrowserSpecificInstructions(browser);
            }
            
            // Set up permission change listener
            result.addEventListener('change', () => {
                if (result.state === 'granted') {
                    getUserCoordinates();
                }
            });
        });
    } else {
        // Fallback for browsers without Permissions API - just try to get location
        getUserCoordinates();
        locationBtn();
    }
}

function detectBrowser() {
    const userAgent = navigator.userAgent;
    
    if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } else if (userAgent.indexOf("Firefox") > -1) {
        return "Firefox";
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1) {
        return "IE";
    } else if (userAgent.indexOf("Edge") > -1) {
        return "Edge";
    } else {
        return "Unknown";
    }
}

function showBrowserSpecificInstructions(browser) {
    let instructions = "";
    
    switch (browser) {
        case "Chrome":
            instructions = "To enable location: Click the lock/info icon in the address bar → Site settings → Allow location";
            break;
        case "Firefox":
            instructions = "To enable location: Click the shield icon in the address bar → Site permissions → Allow location";
            break;
        case "Safari":
            instructions = "To enable location: Open Safari Preferences → Privacy → Location Services → Enable";
            break;
        case "Edge":
            instructions = "To enable location: Click the lock icon in the address bar → Site permissions → Allow location";
            break;
        default:
            instructions = "Please check your browser settings to enable location access";
    }
    
    // Show the instructions in a modal or alert
    util.showModal('locationErrorModal');
    document.getElementById('location-instructions').innerText = instructions;
}

let locationInterval = null;
function getUserCoordinates() {
    if (!navigator.geolocation) return;
    
    navigator.geolocation.getCurrentPosition(
        position => {
            showPosition(position);
            
            // Start periodically updating position
            if (!locationInterval) {
                locationInterval = setInterval(() => {
                    navigator.geolocation.getCurrentPosition(
                        showPosition, 
                        showLocationError, 
                        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
                    );
                }, 30000);
            }
        },
        error => {
            showLocationError(error);
        },
        { 
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 60000
        }
    );
}

function showLocationError(error) {
    if (locationInterval) {
        clearInterval(locationInterval);
        locationInterval = null;
    }

    switch(error.code) {
        case error.PERMISSION_DENIED:
        case 1:
            document.getElementById('location-error').innerText = "Location access denied. Please enable location access in your browser settings.";
            break;
        case error.POSITION_UNAVAILABLE:
            document.getElementById('location-error').innerText = "Location information is unavailable. Please check your connection and try again.";
            break;
        case error.TIMEOUT:
            document.getElementById('location-error').innerText = "The request to get your location timed out. Please try again.";
            break;
        case error.UNKNOWN_ERROR:
            document.getElementById('location-error').innerText = "An unknown error occurred. Please try again.";
            break;
    }
}
let userMarker = null;
let userCircle = null;
let initalPositionLoad = false;
function showPosition(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;

    // Remove existing user location markers if they exist
    if (userMarker) {
        map.removeLayer(userMarker);
    }
    if (userCircle) {
        map.removeLayer(userCircle);
    }

    // Create a custom icon for user location
    const userIcon = L.divIcon({
        className: 'user-location-marker',
        html: '<div class="ring-container"><div class="circle"></div><div class="ringring"></div></div>',
        iconSize: [20, 20],
        iconAnchor: [10, 10]
    });

    // Add marker and accuracy circle
    userMarker = L.marker([latitude, longitude], {
        icon: userIcon,
        zIndexOffset: 1000
    }).addTo(map);

    /*userCircle = L.circle([latitude, longitude], {
        radius: position.coords.accuracy,
        color: '#4B5563',
        fillColor: '#4B5563',
        fillOpacity: 0.1,
        weight: 1
    }).addTo(map);*/

    // Center map on user location
    if (initalPositionLoad) {
        initalPositionLoad = false;
        map.setView([latitude, longitude], 14);
    }
}

export function activityFilterUpdate() {
    const myLikedEl = document.getElementById('my-liked-filter');
    const myRatedEl = document.getElementById('my-rated-filter');

    if (myLikedEl) {
        const v = myLikedEl.value;
        filter.myLiked = (v === 'liked' || v === 'unliked') ? v : 'all';
    }
    if (myRatedEl) {
        const v = myRatedEl.value;
        filter.myRated = (v === 'rated' || v === 'unrated') ? v : 'all';
    }

    const collapseEl = document.getElementById('my-activity-collapse');
    if (collapseEl && ((filter.myLiked && filter.myLiked !== 'all') || (filter.myRated && filter.myRated !== 'all'))) {
        setCollapseOpen(collapseEl, true);
    }

    filterUpdate();
}

let cityMarkers = {};
function getReducedCities() {
    if (!Array.isArray(cities)) return [];
    const seen = new Set();
    const result = [];
    for (const c of cities) {
        const key = c.cityName || c.name || c.zip;
        if (!seen.has(key)) {
            seen.add(key);
            result.push(c);
        }
    }
    return result;
}

function displayCityMarkers() {
    const list = getReducedCities();
    for (const c of list) {
        const key = c.zip || c.cityName || c.name;
        if (!key || cityMarkers[key]) continue;
        if (!c.latitude || !c.longitude) continue;

        const label = c.cityName || c.name || c.zip || '';
        const path = `/city/${encodeURIComponent(label)}`;

        const m = L.marker([c.latitude, c.longitude], {
            icon: marker,
            opacity: 0,
            interactive: true
        })
        .bindPopup(`<a href="${path}">${label}</a>`)
        .addTo(map);

        cityMarkers[key] = { marker: m, city: c };
    }

    // Initial toggle based on current zoom
    handleMarkerVisibility(map.getZoom());
}